var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartaoDeCredito(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.046,
    height: 13.534,
    viewBox: "0 0 18.046 13.534",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cartao-de-credito",
    transform: "translate(0 -3)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_97",
    "data-name": "Elipse 97",
    cx: 1,
    cy: 1.5,
    rx: 1,
    ry: 1.5,
    transform: "translate(3 11)",
    fill: "#6a15c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20433",
    "data-name": "Caminho 20433",
    d: "M14.286,3H3.759A3.764,3.764,0,0,0,0,6.759v6.015a3.764,3.764,0,0,0,3.759,3.759H14.286a3.764,3.764,0,0,0,3.759-3.759V6.759A3.764,3.764,0,0,0,14.286,3ZM3.759,4.5H14.286a2.256,2.256,0,0,1,2.256,2.256H1.5A2.256,2.256,0,0,1,3.759,4.5ZM14.286,15.03H3.759A2.256,2.256,0,0,1,1.5,12.775V8.263H16.542v4.511A2.256,2.256,0,0,1,14.286,15.03Z",
    transform: "translate(0 0)",
    fill: "#6a15c8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartaoDeCredito);
export default __webpack_public_path__ + "static/media/cartao-de-credito.6b5f9a135b5cdf54c4be2dbf6168edc3.svg";
export { ForwardRef as ReactComponent };